<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Gift Stock
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="store"
                outlined
                v-model="form.store_id"
                :items="storeItems"
                label="Store"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                readonly
                disabled
                :error-messages="errors.store_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="3">
              <div class="quantity-container">
                <v-btn
                  :color="isPositive ? 'success' : 'error'"
                  :dark="true"
                  @click="isPositive = !isPositive"
                  class="toggle-btn"
                  height="56"
                  min-width="60"
                  tile
                >
                  <v-icon>{{ isPositive ? "mdi-plus" : "mdi-minus" }}</v-icon>
                </v-btn>
                <v-text-field
                  v-model="quantityValue"
                  outlined
                  label="Quantity"
                  type="number"
                  min="0"
                  :rules="quantityRules"
                  class="quantity-field"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </v-col>
            <v-col sm="3">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-textarea
                v-model="form.remarks"
                outlined
                label="Remarks"
                prepend-inner-icon="mdi-comment-text-outline"
                rows="3"
                counter
                clearable
              ></v-textarea>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Gift Stock
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "StoreGiftStockCreatePage",
  data() {
    return {
      form: {
        store_gift_id: null,
        store_id: null,
        name: "",
        date: "",
        quantity: "",
        remarks: "",
      },
      store_gift: {},
      giftItems: [],
      storeItems: [],
      isLoading: false,
      menu: false,
      isPositive: true,
      quantityValue: "",
      quantityRules: [
        (v) => !!v || "Quantity is required",
        (v) => (v && v > 0) || "Quantity must be greater than 0",
        (v) => (v && !isNaN(v)) || "Quantity must be a number",
      ],
    };
  },
  computed: {
    finalQuantity() {
      if (!this.quantityValue) return "";
      return this.isPositive
        ? Math.abs(this.quantityValue)
        : -Math.abs(this.quantityValue);
    },
  },
  watch: {
    finalQuantity(newVal) {
      this.form.quantity = newVal;
    },
  },
  mounted() {
    this.getMasters();
    console.log("form", this.form);
  },
  methods: {
    async getData() {
      let encryptedId = this.$route.params.storeGiftId;
      await axios
        .get(`/store_gifts/${encryptedId}`)
        .then((response) => {
          this.store_gift = response.data.data;
          this.old_json = response.data.data;
          this.form.store_gift_id = this.store_gift.id;
          this.form.gift_id = this.store_gift.gift_id;
          this.form.store_id = this.store_gift.store_id;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      console.log("form", this.form);
    },
    async getMasters() {
      await axios
        .get(`gift_stocks/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.gifts.forEach((gift) => {
            this.giftItems.push({
              id: gift.id,
              text: gift.name,
              value: gift.id,
            });
          });
          //Stores
          masters.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.business_name,
              value: store.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
      this.getData();
    },
    async save() {
      try {
        // Validation
        if (!this.quantityValue || this.quantityValue <= 0) {
          this.$toast.error("Please enter a valid quantity");
          return;
        }
        if (!this.form.date) {
          this.$toast.error("Please select a date");
          return;
        }

        this.isLoading = true;
        console.log("Form data being sent:", this.form);

        await axios.post("/gift_stocks", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$toast.success("Gift stock saved successfully");
        this.$router.back();
      } catch (e) {
        console.log(e);
        this.isLoading = false;
        this.$toast.error("Error saving gift stock");
      }
    },
  },
};
</script>

<style scoped>
.quantity-container {
  display: flex;
  align-items: flex-start;
}

.toggle-btn {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: none !important;
  flex-shrink: 0;
}

.quantity-field {
  margin-left: 0;
  flex-grow: 1;
}

.quantity-field >>> .v-input__control {
  min-height: 56px;
}

.quantity-field >>> .v-input__control .v-input__slot {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  min-height: 56px;
}

.quantity-field >>> .v-text-field--outlined fieldset {
  border-left: none !important;
}

.quantity-field >>> .v-text-field--outlined .v-input__slot {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.quantity-field
  >>> .v-text-field--outlined
  > .v-input__control
  > .v-input__slot
  fieldset {
  border-left: none !important;
}

/* Ensure proper alignment when validation messages appear */
.quantity-field >>> .v-text-field__details {
  margin-top: 4px;
}
</style>
